import { round } from '@/utils/mathUtils';

export function formatNumberWithCommas(
  num: number | null | undefined,
  decimals: number = 2,
  locale: string = 'en-US',
): string {
  if (typeof num !== 'number' || isNaN(num) || num === 0) {
    return '-';
  }

  const rounded = round(num, decimals);

  return rounded.toLocaleString(locale, {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  });
}
